/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GlobalResponsesToCommentsRatioDeltaQueryVariables = Types.Exact<{
  isUserAllowedToReadComments: Types.Scalars['Boolean'];
  surveyContentType: Types.SurveyContentType;
}>;


export type GlobalResponsesToCommentsRatioDeltaQuery = { commentsStatistics: { responsesToCommentsRatioDelta: number } };


export const GlobalResponsesToCommentsRatioDeltaDocument = gql`
    query GlobalResponsesToCommentsRatioDelta($isUserAllowedToReadComments: Boolean!, $surveyContentType: SurveyContentType!) {
  commentsStatistics: getStatisticsGlobal(surveyContentType: $surveyContentType) @include(if: $isUserAllowedToReadComments) {
    responsesToCommentsRatioDelta: treated_recipient_comment_delta
  }
}
    `;

/**
 * __useGlobalResponsesToCommentsRatioDeltaQuery__
 *
 * To run a query within a React component, call `useGlobalResponsesToCommentsRatioDeltaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalResponsesToCommentsRatioDeltaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalResponsesToCommentsRatioDeltaQuery({
 *   variables: {
 *      isUserAllowedToReadComments: // value for 'isUserAllowedToReadComments'
 *      surveyContentType: // value for 'surveyContentType'
 *   },
 * });
 */
export function useGlobalResponsesToCommentsRatioDeltaQuery(baseOptions: Apollo.QueryHookOptions<GlobalResponsesToCommentsRatioDeltaQuery, GlobalResponsesToCommentsRatioDeltaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalResponsesToCommentsRatioDeltaQuery, GlobalResponsesToCommentsRatioDeltaQueryVariables>(GlobalResponsesToCommentsRatioDeltaDocument, options);
      }
export function useGlobalResponsesToCommentsRatioDeltaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalResponsesToCommentsRatioDeltaQuery, GlobalResponsesToCommentsRatioDeltaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalResponsesToCommentsRatioDeltaQuery, GlobalResponsesToCommentsRatioDeltaQueryVariables>(GlobalResponsesToCommentsRatioDeltaDocument, options);
        }
export type GlobalResponsesToCommentsRatioDeltaQueryHookResult = ReturnType<typeof useGlobalResponsesToCommentsRatioDeltaQuery>;
export type GlobalResponsesToCommentsRatioDeltaLazyQueryHookResult = ReturnType<typeof useGlobalResponsesToCommentsRatioDeltaLazyQuery>;
export type GlobalResponsesToCommentsRatioDeltaQueryResult = Apollo.QueryResult<GlobalResponsesToCommentsRatioDeltaQuery, GlobalResponsesToCommentsRatioDeltaQueryVariables>;